module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": 'main-form-' + this.group
    }
  }, [_c('section', {
    staticClass: "col col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "value": "pf",
      "checked": "checked",
      "autocomplete": "off",
      "name": "type"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "pf")
    },
    on: {
      "change": function($event) {
        _vm.type = "pf"
      }
    }
  }), _vm._v(" Pessoa Física\n          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "value": "pj",
      "autocomplete": "off",
      "name": "type"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "pj")
    },
    on: {
      "change": function($event) {
        _vm.type = "pj"
      }
    }
  }), _vm._v("Pessoa Jurídica\n              "), _vm._m(1)])]), _vm._v(" "), _vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field['name'] === 'cpf' && _vm.type === 'pf' ? field.mask : field['name'] === 'cpf' && _vm.type === 'pj' ? '11.111.111/1111-11' : field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Tipo de cadastro\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("   "), _c('span', {
    staticStyle: {
      "display": "none"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c3fde14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/Customer/Edit/EditForm.vue
// module id = 1021
// module chunks = 1